import { createContext, useState } from "react";
import validator from "validator";

interface PaymentForm {
  name: string;
  setName: React.Dispatch<React.SetStateAction<string>>;
  dni: string;
  setDni: React.Dispatch<React.SetStateAction<string>>;
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  phoneNumber: string;
  setPhoneNumber: React.Dispatch<React.SetStateAction<string>>;
  paymentErrors: any;
  validatePaymentForm: any;
}

export interface PreferenceOptions {
  title: string;
  quantity: number;
  unitPrice: number;
}

interface PreferenceResponse {
  preferenceId: string;
  setPreferenceId: React.Dispatch<React.SetStateAction<string>>;
}

export interface PaymentContextProps {
  paymentForm: PaymentForm;
  paymentContextClear: any;
  preferenceOptions: PreferenceOptions;
  preferenceResponse: PreferenceResponse
}

export const PaymentContext = createContext(null);

export const PaymentContextProvider = ({ children }: any) => {
  const [name, setName] = useState<string>("");
  const [dni, setDni] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [preferenceId, setPreferenceId] = useState<string>("");
  const [paymentErrors, setPaymentErrors] = useState<any>(null);

  const validatePhoneNumber = (phoneNumber: string) => {

    const phoneNumberFinal = "549" + phoneNumber;
    
    if (!validator.isMobilePhone(phoneNumberFinal, "es-AR")) {
      return "Número de teléfono no válido";
    }

    return null;
  };

  const validatePaymentForm = () => {
    let hasErrors = false;
    const errors: any = {};
    const requiredField = "Requerido *";

    if (!name) {
      errors.name = requiredField;
      hasErrors = true;
    }

    if (!dni) {
      errors.dni = requiredField;
      hasErrors = true;
    }

    if (!email) {
      errors.email = requiredField;
      hasErrors = true;
    } else if (!validator.isEmail(email)) {
      errors.email = "Email no válido";
      hasErrors = true;
    }

    if (!phoneNumber) {
      errors.phoneNumber = requiredField;
      hasErrors = true;
    } else {
      const phoneNumberError = validatePhoneNumber(phoneNumber);
      if (phoneNumberError) {
        errors.phoneNumber = phoneNumberError;
        hasErrors = true;
      }
    }

    if (hasErrors) {
      setPaymentErrors(errors);
      return false;
    }

    setPaymentErrors(null);
    return true;
  };

  const paymentContextClear = () => {
    setName("");
    setDni("");
    setEmail("");
    setPhoneNumber("");
    setPaymentErrors(null);
  };

  const paymentForm = {
    name,
    setName,
    dni,
    setDni,
    email,
    setEmail,
    phoneNumber,
    setPhoneNumber,
    paymentErrors,
    validatePaymentForm,
  };

  const preferenceOptions = {
    title: '',
    quantity: 0,
    unitPrice: 0,
  }

  const preferenceResponse = {
    preferenceId,
    setPreferenceId
  }

  // Global State like "Redux"
  const contextProps: PaymentContextProps = {
    paymentForm,
    paymentContextClear,
    preferenceOptions,
    preferenceResponse
  };

  return (
    // @ts-ignore
    <PaymentContext.Provider value={contextProps}>
      {children}
    </PaymentContext.Provider>
  );
};
